import { Avatar, Box, Button, Checkbox, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import { Formik } from 'formik';
import { useState } from 'react';
import * as Auth from '../../shared/auth';
import { CognitoUser } from 'amazon-cognito-identity-js';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { TextInput } from '../../components/form';

interface ConfirmEmailPageProps {
  user: string;
}

const ConfirmEmailPage = (props: ConfirmEmailPageProps) => {
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (values: {code: string}) => {
      setSubmitting(true);

      try {
          await Auth.confirmSignUp(props.user, values.code);
      } catch(e){
          console.log(e);
      }
      finally {
          setSubmitting(false);
      }
    }

    return <>
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          <Formik initialValues={{ code: "" }}
              onSubmit={(values) => onSubmit(values)}>
              {({
              handleSubmit,
            }) => (
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextInput
                  label="Confirm code"
                  name="code"
                  type="text"
                  disabled={submitting}
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={submitting}
              sx={{ mt: 3, mb: 2 }}
            >
              Confirm sign up
            </Button>
          </Box>
        )}
          </Formik>
        </Box>
    </>
}

export default ConfirmEmailPage;